module.exports = __webpack_public_path__ + "static/polityka-2c320a305b445b4145a7468c6d724687.pdf";